import useStrings from "../../../localization/useStrings"
import { SparklesIcon } from "../icons"
import styles from "./PlanCard.module.scss"

interface PlanCardProps {
  duration: string
  price: string
  perMonthValue: string
  savings: string | null
  popular: boolean
  selected: boolean
  isUltimate?: boolean
  isLifetime?: boolean
  onSelect: () => void
}

const PlanCard = ({
  duration,
  price,
  perMonthValue,
  savings,
  popular,
  selected,
  isUltimate,
  isLifetime,
  onSelect,
}: PlanCardProps) => {
  const strings = useStrings()

  return (
    <button
      onClick={onSelect}
      className={`${styles.card} ${selected ? styles.selected : ""} ${popular ? styles.popular : ""} ${isUltimate ? styles.ultimate : ""} ${isLifetime ? styles.lifetime : ""}`}
    >
      {popular && (
        <div className={styles.badge}>
          <SparklesIcon className={styles.badgeIcon} />
          {strings.threeStepExpiration.bestValue}
        </div>
      )}

      <div className={styles.radio}>
        {selected && <div className={styles.radioInner} />}
      </div>

      <div className={styles.left}>
        <div className={styles.durationRow}>
          <span className={styles.duration}>{duration}</span>
          {savings && <span className={styles.savings}>{savings}</span>}
        </div>
        {!isLifetime && (
          <span
            className={`${styles.price} ${selected ? styles.priceSelected : ""}`}
          >
            {price}
          </span>
        )}
      </div>

      <div className={styles.right}>
        <span className={styles.perMonth}>{perMonthValue}</span>
        {!isLifetime && (
          <span className={styles.perMonthLabel}>
            {strings.threeStepExpiration.perMonth}
          </span>
        )}
      </div>
    </button>
  )
}

export default PlanCard
